var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"holder"},[_c('div',{staticClass:"copyright"},[_vm._v("Copyright © SAEDA. All rights reserved.")]),_c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":require("../../assets/logo-footer.png"),"alt":"logo"}})])])])])
}]

export { render, staticRenderFns }